import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
interface CheckItemProps {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}
export function CheckItem({
  children,
  delay = 0,
  className = ''
}: CheckItemProps) {
  return <motion.div className={`flex items-start gap-3 ${className}`} initial={{
    opacity: 0,
    x: -20
  }} whileInView={{
    opacity: 1,
    x: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5,
    delay
  }} data-id="element-15">
      <span className="flex-shrink-0 mt-1" data-id="element-16">
        <CheckIcon className="w-5 h-5 text-teal-check" strokeWidth={3} data-id="element-17" />
      </span>
      <span className="text-cream/90 leading-relaxed" data-id="element-18">{children}</span>
    </motion.div>;
}